/**
 * Moderation status for city attractions.
 * Seed/admin entries are created as `approved`.
 * Partner-created points start as `needReview`.
 *
 * `rejected` — human admin/moderator decision.
 * `rejected_mcp` — automated (pipeline triage, MCP agent, heuristics); hidden from
 * default admin lists so human rejects stay clean.
 */
export enum AttractionReviewStatusEnum {
    APPROVED = 'approved',
    NEED_REVIEW = 'needReview',
    REJECTED = 'rejected',
    /** Rejected by pipeline triage / city-content MCP (not human moderator). */
    REJECTED_MCP = 'rejected_mcp',
}
